import http from '@/utils/http'
// 报价单列表
export const queryQuoteList = (data) => {
  return http({
    method: 'post',
    url: '/bs/phoenix/quoteOrder/queryQuoteList',
    data,
  })
}
// 报价单详情-自动报价
export const queryQuoteInfo = (data) => {
  return http({
    method: 'post',
    url: '/bs/phoenix/quoteOrder/queryQuoteInfo',
    data,
  })
}
// 报价单详情-人工报价
export const queryUserInquiry = (data) => {
  return http({
    method: 'post',
    url: '/bs/phoenix/quoteOrder/queryUserInquiry',
    data,
  })
}